import View from '../core/View';
import URLUtils from '../util/URLUtils';

export default class LibraryBannerView extends View {

    createView(model) {

        let baseUrl = model['baseUrl'];
        let banners = model['banners'];
        let bannerInterval = model['bannerInterval'];

        let bannerDOM = $('<div>', {
            class: 'banner'
        });

        banners = banners.filter((elem, i, array) => {
            return elem.language == '' || elem.language == this.app.currentDeviceLanguage;
        });

        let slides = $('<div>', {
            id: `${(banners.length > 1) ? 'slides' : ''}`
        }).appendTo(bannerDOM);

        for (let banner of banners) {

            let onClick = undefined;

            let URL_PREFIX_HTTP = 'http://'; 
            let URL_PREFIX_HTTPS = 'https://'; 
            let URL_PREFIX_COI_OPENISSUE = 'cointeractive://openissue/';

            let link;

            if (banner.url.startsWith(URL_PREFIX_COI_OPENISSUE)) {
                let catalogId = banner.url.slice(URL_PREFIX_COI_OPENISSUE.length);
                onClick = () => { this.app.loadCatalogById(catalogId, true); return false; }
                link = $('<a>', {
                    click: (onClick) ? onClick.bind(this) : '',
                    css: {
                        'cursor': 'pointer'
                    }
                }).appendTo(slides);
            } else if (banner.url.startsWith(URL_PREFIX_HTTP) || banner.url.startsWith(URL_PREFIX_HTTPS)) {
                link = $('<a>', {
                    href: banner.url,
                    target: '_blank'
                }).appendTo(slides);
            } else {
                link = $('<a>', {
                    click: () => { return false; }
                }).appendTo(slides);
            }

            $('<img>', {
                src: (banner.image.search('http') >= 0) ? banner.image : URLUtils.getURL(baseUrl + banner.image),
                style: 'width: 100%;'
            }).appendTo(link);
        }

        if (banners.length > 1) {
            let width = banners[0].width;
            let height = banners[0].height;
            this.app.bannerSliderOptions = this.buildSliderOptions(width, height, bannerInterval);
        }

        return bannerDOM;

    }

    buildSliderOptions(width, height, interval) {
        return {
            width: width,
            height: height,
            navigation: {
                active: false,
                // [boolean] Generates next and previous buttons.
                // You can set to false and use your own buttons.
                // User defined buttons must have the following:
                // previous button: class="slidesjs-previous slidesjs-navigation"
                // next button: class="slidesjs-next slidesjs-navigation"
                effect: "slide"
                // [string] Can be either "slide" or "fade".
            },
            play: {
                active: false,
                // [boolean] Generate the play and stop buttons.
                // You cannot use your own buttons. Sorry.
                effect: "slide",
                // [string] Can be either "slide" or "fade".
                interval: interval * 1000,
                // [number] Time spent on each slide in milliseconds.
                auto: true,
                // [boolean] Start playing the slideshow on load.
                swap: true,
                // [boolean] show/hide stop and play buttons
                pauseOnHover: true,
                // [boolean] pause a playing slideshow on hover
                restartDelay: interval * 1000
                // [number] restart delay on inactive slideshow
            }
        }
    }

}